import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../api';
import Layout from '../components/Layout';
import DashboardView, { type DashboardDataFetcher } from '../components/DashboardView';

export default function InfluencerDashboard() {
  const { user } = useAuth();

  // Create data fetcher for influencer endpoints
  const dataFetcher: DashboardDataFetcher = useMemo(
    () => ({
      getMetrics: (range) => api.getInfluencerMetrics(range),
      getMetricsByState: (range) => api.getInfluencerMetricsByState(range),
      getOrders: (params) => api.getInfluencerOrders(params),
      getOrderDetail: (shopifyOrderId) => api.getInfluencerOrderDetail(shopifyOrderId),
    }),
    []
  );

  // Get display name from influencer or use fallback
  const displayName = user?.influencer?.stage_name || user?.influencer?.first_name || '';
  const title = displayName ? `Welcome back, ${displayName}` : 'Dashboard';

  return (
    <Layout>
      <DashboardView
        dataFetcher={dataFetcher}
        title={title}
        subtitle="Here's how your store is performing"
      />
    </Layout>
  );
}
